namespace GeniuzPOS.SalePromoCamp {
    export interface LookupItemCodeForm {
        ItemCode: Serenity.StringEditor;
        ItemDesc: Serenity.StringEditor;
    }

    export class LookupItemCodeForm extends Serenity.PrefixedContext {
        static formKey = 'SalePromoCamp.LookupItemCode';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!LookupItemCodeForm.init)  {
                LookupItemCodeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(LookupItemCodeForm, [
                    'ItemCode', w0,
                    'ItemDesc', w0
                ]);
            }
        }
    }
}
